import React, { useEffect, useState } from "react";
import { FAHRZEUGE } from "../fahrzeuge";
import { useI18n } from "../I18nProvider";

export default function Fahrzeuge() {
  const { t, lang } = useI18n();
  const sprache = ["de", "en", "fr"].includes(lang) ? lang : "de";
  const [listeOffen, setListeOffen] = useState(false);
  const [offen, setOffen] = useState(null);

  useEffect(() => {
    const auf = () => setListeOffen(true);
    window.addEventListener("automah:fahrzeuge", auf);
    return () => window.removeEventListener("automah:fahrzeuge", auf);
  }, []);

  useEffect(() => {
    if (!listeOffen && !offen) return;
    const beiTaste = (e) => {
      if (e.key !== "Escape") return;
      if (offen) setOffen(null);
      else setListeOffen(false);
    };
    const overflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", beiTaste);
    return () => {
      document.body.style.overflow = overflow;
      document.removeEventListener("keydown", beiTaste);
    };
  }, [listeOffen, offen]);



  function istAutomatik(text) {
    const s = (text || "").toLowerCase();
    return s.includes("auto");
  }

  function daten(auto) {
    const getriebe = auto.getriebe?.[sprache];
    return [
      auto.jahr && { fa: "fa-calendar-alt", text: auto.jahr },
      auto.km && { fa: "fa-road", text: auto.km },
      getriebe && {
        art: istAutomatik(getriebe) ? "automatik" : "schalter",
        text: getriebe,
      },
      auto.kraftstoff?.[sprache] && { fa: "fa-gas-pump", text: auto.kraftstoff[sprache] },
    ].filter(Boolean);
  }

  function zeichen(z) {
    if (z.art === "schalter") {
      return (
        <svg className="auto-ico" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 8.2v8.2M12 8.2v8.2M18 8.2v8.2M6 12.3h12"
          />
          <circle cx="6" cy="8.2" r="1.55" fill="currentColor" />
          <circle cx="12" cy="8.2" r="1.55" fill="currentColor" />
          <circle cx="18" cy="8.2" r="1.55" fill="currentColor" />
          <circle cx="6" cy="16.4" r="1.55" fill="currentColor" />
          <circle cx="12" cy="16.4" r="1.55" fill="currentColor" />
          <circle cx="18" cy="16.4" r="1.55" fill="currentColor" />
          <text x="6" y="5.2" textAnchor="middle" fontSize="4.4" fontWeight="800" fill="currentColor">1</text>
          <text x="12" y="5.2" textAnchor="middle" fontSize="4.4" fontWeight="800" fill="currentColor">3</text>
          <text x="18" y="5.2" textAnchor="middle" fontSize="4.4" fontWeight="800" fill="currentColor">5</text>
          <text x="6" y="22.4" textAnchor="middle" fontSize="4.4" fontWeight="800" fill="currentColor">2</text>
          <text x="12" y="22.4" textAnchor="middle" fontSize="4.4" fontWeight="800" fill="currentColor">4</text>
          <text x="18" y="22.4" textAnchor="middle" fontSize="4.4" fontWeight="800" fill="currentColor">R</text>
        </svg>
      );
    }
    if (z.art === "automatik") {
      return (
        <svg className="auto-ico" viewBox="0 0 24 24" aria-hidden="true">
          <rect x="5.2" y="3" width="4.2" height="18" rx="2.1" fill="none" stroke="currentColor" strokeWidth="1.7" />
          <circle cx="7.3" cy="14.6" r="2.35" fill="currentColor" />
          <text x="13.4" y="7.1" fontSize="4.6" fontWeight="800" fill="currentColor">P</text>
          <text x="13.4" y="11.4" fontSize="4.6" fontWeight="800" fill="currentColor">R</text>
          <text x="13.4" y="15.7" fontSize="4.6" fontWeight="800" fill="currentColor">N</text>
          <text x="13.4" y="20" fontSize="4.6" fontWeight="800" fill="currentColor">D</text>
        </svg>
      );
    }
    return <i className={`fas ${z.fa}`} aria-hidden="true"></i>;
  }

  function anfragen(auto) {
    setOffen(null);
    setListeOffen(false);
    window.dispatchEvent(
      new CustomEvent("automah:formular", {
        detail: { typ: "wish_car", auto: auto.titel },
      })
    );
  }

  function raster() {
    return (
      <div className="auto-raster">
        {FAHRZEUGE.map((auto) => (
          <article className="auto-angebot" key={auto.id}>
            <button
              type="button"
              className="auto-foto"
              onClick={() => setOffen(auto)}
            >
              <img src={auto.foto} alt={auto.titel} />
            </button>
            <h3>{auto.titel}</h3>
            <p className="auto-preis">{t("cars.price")}</p>
            <ul className="auto-daten">
              {daten(auto).map((z) => (
                <li key={z.text}>
                  {zeichen(z)}
                  {z.text}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    );
  }

  return (
    <section id="fahrzeuge" className="fahrzeuge">
      <div className="container">
        <h2>{t("cars.title")}</h2>
        <p className="section-subtitle">{t("cars.lead")}</p>
        <div className="fahrzeuge-teaser">
          <button type="button" className="btn" onClick={() => setListeOffen(true)}>
            {t("cars.open")}
          </button>
        </div>
      </div>

      {listeOffen && (
        <div
          className="auto-liste"
          role="dialog"
          aria-modal="true"
          aria-label={t("cars.title")}
        >
          <div className="auto-liste-kopf">
            <h3>{t("cars.title")}</h3>
            <button
              type="button"
              className="overlay-zu"
              onClick={() => {
                setOffen(null);
                setListeOffen(false);
              }}
              aria-label={t("hero.schliessen")}
            >
              ×
            </button>
          </div>
          <div className="auto-liste-inhalt">
            {FAHRZEUGE.length ? (
              raster()
            ) : (
              <div className="auto-leer">
                <p className="auto-leer-titel">{t("cars.soon")}</p>
                <p className="auto-leer-text">{t("cars.soon_text")}</p>
                <button
                  type="button"
                  className="btn"
                  onClick={() => {
                    setListeOffen(false);
                    window.dispatchEvent(
                      new CustomEvent("automah:formular", { detail: "wish_car" })
                    );
                  }}
                >
                  {t("cars.btn")}
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {offen && (
        <div
          className="auto-blick"
          onClick={() => setOffen(null)}
          role="dialog"
          aria-modal="true"
          aria-label={offen.titel}
        >
          <div
            className="auto-blick-kasten"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="auto-blick-zu"
              onClick={() => setOffen(null)}
              aria-label={t("hero.schliessen")}
            >
              ×
            </button>
            <img src={offen.foto} alt={offen.titel} />
            <div className="auto-blick-text">
              <h3>{offen.titel}</h3>
              <ul className="auto-daten">
                {daten(offen).map((z) => (
                  <li key={z.text}>
                    {zeichen(z)}
                    {z.text}
                  </li>
                ))}
              </ul>
              <p className="auto-preis">{t("cars.price")}</p>
              <button type="button" className="btn" onClick={() => anfragen(offen)}>
                {t("cars.btn")}
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
